import React from 'react';
import { Box } from '@mui/material';
import { useNotifications } from '../context/NotificationContext';
import NotificationToast from './NotificationToast';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotifications();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        zIndex: (theme) => theme.zIndex.snackbar + 10,
        pointerEvents: 'none',
      }}
    >
      {notifications.map((notification) => (
        <Box
          key={notification.id}
          sx={{ pointerEvents: 'auto' }}
        >
          <NotificationToast
            notification={notification}
            onClose={() => removeNotification(notification.id)}
          />
        </Box>
      ))}
    </Box>
  );
};

export default NotificationContainer;
